import { computed, type ComputedRef } from 'vue';
import { useRuntimeEnv } from './useRuntimeEnv';

type RuntimeEnv = NonNullable<ReturnType<typeof useRuntimeEnv>>;
type RuntimeEnvWithLatest = RuntimeEnv & {
  features?: {
    latest?: boolean | string;
  };
};

/**
 * Returns whether the latest API card is enabled by runtime configuration.
 */
export function useLatestEnabled(): ComputedRef<boolean> {
  const env = useRuntimeEnv() as RuntimeEnvWithLatest | undefined;
  return computed(() => {
    const latest = env?.features?.latest;
    return latest === true || (typeof latest === 'string' && latest.toLowerCase() === 'true');
  });
}
